import React from 'react'
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import GetCompensationContextProvider, {
    ACTIONS,
    GetCompensationContext,
} from "../../context/GetCompensationContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from '../../../../common/components/CGE';
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const GetReliquidationPublic = ({ titleReliquidation, textFetchError, descripcioneReliquidationPublic,
    textAlertFilledField, loading, setLoading, setGlobalAlert }) => {
    const properties = React.useContext(ApplicationPropertiesContext);
    const [state, dispatch] = React.useContext(GetCompensationContext);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [decretoSelected, setDecretoSelected] = React.useState('');
    const [decretoLabelSelected, setLabelDecretoSelected] = React.useState("");
    const [numberClient, setNumberClient] = React.useState('');
    const [listOptionReliquidation, setListOptionReliquidation] = React.useState([]);
    const [emptyError, setEmptyError] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    let listCartolaReliquidation = state.listCartolaReliquidation ? state.listCartolaReliquidation : []

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            if (numberClient && decretoSelected && !verifReCaptcha) {
                setEmptyError(false)
            } else {
                setEmptyError(true)
            }
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleChangeNumberCliente(e) {
        setNumberClient(e.target.value);
    }

    function handleChange(e) {
        setDecretoSelected(e.target.value);
        setLabelDecretoSelected(e.target.options[e.target.options.selectedIndex].label);
    }

    function handleClickButton() {
        if (numberClient && decretoSelected && verifReCaptcha) {
            setLoading(true);
            dispatch({
                payload: [numberClient, decretoSelected, decretoLabelSelected],
                type: ACTIONS.SET_CURRENT_ARRAY,
            })
        } else {
            setLoading(false);
            setEmptyError(true)
            if(!numberClient && !decretoSelected && !verifReCaptcha){
                setGlobalAlert(textAlertFilledField, "warning");
            } else if(numberClient && decretoSelected && !verifReCaptcha){
                setGlobalAlert("Falta validar que no eres un Robot.", "warning");

            }
            dispatch({
                payload: [],
                type: ACTIONS.SET_CURRENT_ARRAY,
            })
        }
    }

    React.useEffect(() => {
        setLoading(true);
        dispatch({
            payload: true,
            type: ACTIONS.SET_LOAD_PAGE,
        });
    }, []);

    React.useEffect(() => {
        if (numberClient && decretoSelected && verifReCaptcha) {
            setEmptyError(false)
        }
    }, [numberClient || decretoSelected])

    React.useEffect(() => {
        setEmptyError(false)
    }, [])

    React.useEffect(() => {
        if (Object.keys(state.responseReliquidation)?.length !== 0 || state.responseReliquidation?.byteLength || state.errorFetch !== null) {
            setLoading(false);
        }
    }, [state.responseReliquidation, state.errorFetch]);

    React.useEffect(() => {
        //Cartola de Reliquidación
        if (state.listCartolaReliquidation) {
            let listOptionReliquidationAux = [];
            listCartolaReliquidation.detalle?.items.map((obj) => {
                listOptionReliquidationAux.push({ label: obj['TEXTEXP'], value: obj['IDRELIQ'] })
                setLoading(false);
                if (!decretoSelected) {
                    setDecretoSelected(listOptionReliquidationAux[0].value)
                    setLabelDecretoSelected(listOptionReliquidationAux[0].label)
                }
            });
            setListOptionReliquidation(listOptionReliquidationAux);
        }

    }, [state.listCartolaReliquidation])


    React.useEffect(() => {

        if (state.responseReliquidation?.status === 500) {
            setGlobalAlert(textFetchError, "warning", true, "Advertencia");
        } else if (state.responseReliquidation?.message) {
            setGlobalAlert(state.responseReliquidation?.message, "warning", true, "Advertencia");
        }

    }, [state.responseReliquidation]);

    return (
        <div id="container-get-compensation-public">
            <div>
                <CGE.Panel title={titleReliquidation} description={descripcioneReliquidationPublic}>
                    <CGE.PanelContainer
                        alingItensCenter={true}
                        size="md"
                    >
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Nro. de Cliente: "
                            handleChange={handleChangeNumberCliente}
                            idFormElement="numberClientId"
                            typeFormElement="text"
                            typeElement="input-mask"
                            maxLength="12"
                            formatChars={{
                                9: "[0-9]"
                            }}
                            mask="999999999999"
                            propsLabelInfoContent={propsLabelInfoContent}
                            mandatoryElement={true}
                            msgError={!numberClient && emptyError && "Debes ingresar un Nro. de Cliente."}
                            onInput={(e) => e.target.value = e.target.value.slice(0, 12)}
                            hasError={!numberClient && emptyError ? true : false}
                            value={numberClient}
                        />
                        <CGE.FormsField
                            horizontal={true}
                            labelName="Decreto de Reliquidación: "
                            labelStyle={{ width: '250px' }}
                            handleChange={handleChange}
                            idFormElement="numberClientIdSelect"
                            typeFormElement="text"
                            mandatoryElement={true}
                            typeElement="select"
                            listOptions={listOptionReliquidation}
                            value={decretoSelected}
                        />
                    </CGE.PanelContainer>
                    <div className="d-flex divClayFormMobile align-items-center flex-column">
                        <CGE.PanelContainer
                            alingItensCenter={true}
                            size="md"
                        >
                            <CGE.FieldRecaptcha
                                horizontal={true}
                                onChange={onChangeReCaptcha}
                                sitekey={properties.api_key_recaptcha}
                                style={{ width: '260px' }}
                            />
                        </CGE.PanelContainer>
                        <CGE.Button
                            label="Generar Cartola"
                            onClick={() => handleClickButton()}
                            type="primary"
                        />
                    </div>
                </CGE.Panel>
            </div>
            {loading && <Loading />}
        </div>
    )
}

const GetCompensationPublicWithProvider = ({
    titleReliquidation,
    textFetchError,
    descripcioneReliquidationPublic,
    textAlertFilledField,
    loading,
    setLoading,
    setGlobalAlert
}) => (
    <GetCompensationContextProvider>
        <GetReliquidationPublic
            titleReliquidation={titleReliquidation}
            descripcioneReliquidationPublic={descripcioneReliquidationPublic}
            textFetchError={textFetchError}
            textAlertFilledField={textAlertFilledField}
            loading={loading}
            setLoading={setLoading}
            setGlobalAlert={setGlobalAlert}
        />
    </GetCompensationContextProvider>
);
export default GetCompensationPublicWithProvider;